import React from 'react';
import { FormattedMessage } from 'react-intl';
import feesPropType from 'constants/propTypes/fees';
import { DB_FEE_CODE } from 'constants/tariffCodes';

import FormattedCurrency from 'components/ui/FormattedCurrency';
import AlertBox from 'components/ui/AlertBox';
import { StyledBookingFee, StyledSummary, StyledParagraph, StyledAlertWrapper } from './Receipt.styles';
import PropTypes from 'prop-types';

const FeesBreakdown = ({ fees = [], direction = 'outbound' }) =>
  fees.length > 0 ? (
    fees.map(({ itemRef, code, name, quantity, price, total, currency }, index) => (
      <React.Fragment key={`${index}_${itemRef}--${direction}`}>
        <StyledBookingFee data-cy={`other-fee-${direction}`}>
          <StyledSummary>
            <StyledParagraph>
              <strong>{name}</strong>
            </StyledParagraph>
            <StyledParagraph>
              <FormattedMessage id="paymentsTab.code" />: {code}
            </StyledParagraph>
            <StyledParagraph>
              <FormattedMessage id="paymentsTab.quantity" />: {quantity}
            </StyledParagraph>
            <StyledParagraph>
              <FormattedMessage id="paymentsTab.cost" />: <FormattedCurrency amount={Math.abs(price)} currency={currency} />
            </StyledParagraph>
            <StyledParagraph>
              <FormattedMessage id="paymentsTab.totalCost" />: <FormattedCurrency amount={Math.abs(total)} currency={currency} />
            </StyledParagraph>
          </StyledSummary>
        </StyledBookingFee>
        {code === DB_FEE_CODE && (
          <StyledAlertWrapper>
            <AlertBox variant={AlertBox.variants.WARNING} dataCy="db-fee-warning">
              <FormattedMessage id="dbVoucher.issuedToCustomer" />
            </AlertBox>
          </StyledAlertWrapper>
        )}
      </React.Fragment>
    ))
  ) : (
    <FormattedMessage id="paymentsTab.none" />
  );

FeesBreakdown.propTypes = {
  fees: feesPropType,
  direction: PropTypes.string
};

export default FeesBreakdown;
